export default __webpack_public_path__ + "static/media/Samim Faiz.4fba9579.png";